import { render } from "./RecentProject2.vue?vue&type=template&id=5eadc588&scoped=true"
import script from "./RecentProject2.vue?vue&type=script&lang=js"
export * from "./RecentProject2.vue?vue&type=script&lang=js"

import "./RecentProject2.vue?vue&type=style&index=0&id=5eadc588&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5eadc588"

export default script